import React, { useState } from "react";
import emailjs from "@emailjs/browser";

const ContactForm = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState({ type: "idle", message: "", detail: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: "idle", message: "", detail: "" });

    try {
      await emailjs.send(
        "service_ugl5sne",
        "template_k3eqjev",
        {
          name: form.name,
          email: form.email,
          message: form.message,
          to_email: "ankityadav@rtjobspot.co.in",
        },
        { publicKey: "8uwlW0u3uT8WCsUpX" }
      );

      setStatus({
        type: "success",
        message: "Thank you! Your message has been sent successfully.",
        detail: "",
      });
      setForm({ name: "", email: "", message: "" });
    } catch (error) {
      console.error("EmailJS contact form error:", error);
      setStatus({
        type: "error",
        message: "Your email could not be sent. Your message is still saved below; you can send it through WhatsApp instead.",
        detail: error?.text || error?.message || "No details were returned by the email service.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section
      id="contact"
      className="bg-gradient-to-br from-background to-neutral-light py-20"
    >
      <div className="mx-auto grid max-w-6xl gap-10 px-4 sm:px-6 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
        <div>
          <p className="mb-3 text-xs font-bold uppercase tracking-[0.22em] text-secondary-dark">
            Start a conversation
          </p>
          <h2 className="text-3xl font-black leading-tight text-primary-dark md:text-4xl">
            Let’s talk about what you want to grow.
          </h2>
          <p className="mt-4 max-w-lg leading-7 text-slate-600">
            Tell us a little about your goals. We’ll use your message to understand what kind of support could help your business move forward.
          </p>
          <a
            href="https://wa.me/+917887260088"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 inline-flex rounded-full border border-primary/15 px-5 py-2.5 text-sm font-bold text-primary transition hover:border-secondary hover:text-secondary-dark"
          >
            Prefer WhatsApp? Chat with us
          </a>
        </div>

        <form
          onSubmit={handleSubmit}
          className="space-y-5 rounded-xl border border-slate-200 bg-white p-6 shadow-[0_20px_50px_rgba(15,23,42,0.08)] md:p-8"
        >
          <div>
            <label htmlFor="contact-name" className="mb-1.5 block text-sm font-semibold text-primary-dark">
              Name
            </label>
            <input
              id="contact-name"
              name="name"
              type="text"
              autoComplete="name"
              placeholder="Your name"
              value={form.name}
              onChange={handleChange}
              required
              className="w-full rounded-lg border border-slate-300 bg-white px-4 py-3 text-primary-dark placeholder:text-slate-400 focus:border-secondary focus:outline-none focus:ring-2 focus:ring-secondary/20"
            />
          </div>
          <div>
            <label htmlFor="contact-email" className="mb-1.5 block text-sm font-semibold text-primary-dark">
              Email
            </label>
            <input
              id="contact-email"
              name="email"
              type="email"
              autoComplete="email"
              placeholder="you@company.com"
              value={form.email}
              onChange={handleChange}
              required
              className="w-full rounded-lg border border-slate-300 bg-white px-4 py-3 text-primary-dark placeholder:text-slate-400 focus:border-secondary focus:outline-none focus:ring-2 focus:ring-secondary/20"
            />
          </div>
          <div>
            <label htmlFor="contact-message" className="mb-1.5 block text-sm font-semibold text-primary-dark">
              What would you like help with?
            </label>
            <textarea
              id="contact-message"
              name="message"
              placeholder="Share your goals or current challenge"
              value={form.message}
              onChange={handleChange}
              required
              className="min-h-32 w-full resize-y rounded-lg border border-slate-300 bg-white px-4 py-3 text-primary-dark placeholder:text-slate-400 focus:border-secondary focus:outline-none focus:ring-2 focus:ring-secondary/20"
            />
          </div>
          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full rounded-lg bg-primary py-3 font-semibold text-white transition hover:bg-primary-light focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-secondary/30 disabled:cursor-not-allowed disabled:opacity-70"
          >
            {isSubmitting ? "Sending..." : "Send message"}
          </button>

          {status.message && (
            <div
              role={status.type === "error" ? "alert" : "status"}
              aria-live={status.type === "error" ? "assertive" : "polite"}
              className={`rounded-lg px-3 py-2 text-sm ${
                status.type === "success"
                  ? "bg-green-100 text-green-700"
                  : "bg-red-100 text-red-700"
              }`}
            >
              <p>{status.message}</p>
              {status.type === "error" && (
                <>
                  <p className="mt-2 break-words text-xs opacity-80">Email service: {status.detail}</p>
                  <a
                    href={`https://wa.me/917887260088?text=${encodeURIComponent(`Name: ${form.name}\nEmail: ${form.email}\nMessage: ${form.message}`)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-3 inline-flex rounded-full bg-green-700 px-4 py-2 font-semibold text-white transition hover:bg-green-800"
                  >
                    Send through WhatsApp
                  </a>
                </>
              )}
            </div>
          )}
        </form>
      </div>
    </section>
  );
};

export default ContactForm;
